import { useState, useEffect } from "react";
import { storage } from "../utils/storage";

const CheckLoginStatus = () => {
  const [loginStatus, setLogin] = useState(false);

  /**
   * Check login Status
   */
  useEffect(() => {
    if (storage.getItem("access_token")) {
      setLogin(true);
    }
  }, []);

  return { loginStatus };
};

export default CheckLoginStatus;
